import { httpRequest } from 'http'
import { formatMessage } from 'locale'

import WINDOW_TITLES from 'window_titles'

import submitUserFlag from 'state/actions/user_flags'
import { initData } from 'helpers/schedule'

const DEFAULT_SCHEDULE_DAYS = 14

export const REQUEST_ERROR = 'schedule/REQUEST_ERROR'
export const SELECT_PLAYDAY = 'schedule/SELECT_PLAYDAY'
export const REQUEST_START = 'schedule/REQUEST_START'
export const REQUEST_SUCCESS = 'schedule/REQUEST_SUCCESS'
export const OPEN = 'schedule/OPEN'
export const OPEN_SKIP = 'schedule/OPEN_SKIP'

export function selectPlayday(selected_playday_id) {
    return {
        type: SELECT_PLAYDAY,
        payload: {
            selected_playday_id: selected_playday_id,
        },
    }
}


export function openSchedule() {

    return (dispatch, getState) => {
        const { settings: { isInGameBrowser }, userFlags: { schedule_visited } } = getState()

        const url = `${window.location.protocol}//${window.location.host}/schedule.html?1`

        // Show in regular browser for dev and QA purposes
        if (!isInGameBrowser) {
            window.location.assign(url)
        }

        const title = formatMessage(WINDOW_TITLES.schedule)

        if (!schedule_visited) {
            dispatch(submitUserFlag('schedule_visited'))
        }

        return dispatch({
            type: OPEN,
            meta: {
                webToClient: {
                    handler: 'openBrowser',
                    params: {
                        url,
                        width: 1008,
                        height: 630,
                        showCreateWaiting: true,
                        title,
                    },
                },
            },
        })
    }
}

export function startRequest() {
    return {
        type: REQUEST_START,
    }
}

export function requestError() {
    return {
        type: REQUEST_ERROR,
    }
}

export function requestSuccess(response) {
    return {
        type: REQUEST_SUCCESS,
        payload: { response: initData(response) },
    }
}

export function requestScheduleData(schedule_period = DEFAULT_SCHEDULE_DAYS) {
    return (dispatch) => {
        dispatch(startRequest())

        let url = `/game_api/schedule?schedule_period=${schedule_period}`

        httpRequest(url).then(
            response => dispatch(requestSuccess(response)),
            () => dispatch(requestError())
        )
    }
}




// WEBPACK FOOTER //
// ./state/actions/schedule.js